import Pagination from "../utils/Pagination";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";

export default function Trainer({
  peoples,
  totalData,
  currentPage,
  itemsPerPage,
  handlePageChange,
  handleItemsPerPageChange,
  changeStatusTrainer,
}) {
  const userRole = sessionStorage.getItem("userRole");
  const userId = sessionStorage.getItem("userId");

  // Handle case: peoples may already be array OR inside peoples.trainerId
  const trainerList = Array.isArray(peoples)
    ? peoples
    : peoples?.trainerId || [];

  return (
    <>
      <div className="container">
        <div className="row">
          {trainerList?.length > 0 ? (
            trainerList.map((trainer, index) => (
              <div className="col-sm-12 text-capitalize" key={index}>
                <div
                  className={`card mb-2 ${
                    trainer?._id === peoples?.ownerId?._id
                      ? "px-2 py-3"
                      : "p-2"
                  }`}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="fs-6 my-0">
                      {trainer?.name}
                      <span className="email">({trainer?.email})</span>
                    </h5>

                    {userRole != 3 && (
                      <div className="d-flex">
                        <span>
                          {trainer?._id === peoples?.ownerId?._id && "Owner"}
                        </span>

                        {trainer?._id !== peoples?.ownerId?._id &&
                          peoples?.ownerId?._id === userId && (
                            <div className="dropdown">
                              <IconButton
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <MoreVertIcon />
                              </IconButton>
                              <ul className="dropdown-menu">
                                <li>
                                  <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                      changeStatusTrainer(trainer?._id)
                                    }
                                  >
                                    Remove
                                  </a>
                                </li>
                              </ul>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <h1>No Trainer Present!!</h1>
          )}
        </div>

        <div className="d-flex justify-content-end">
          <Pagination
            count={totalData}
            page={currentPage}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>
      </div>
    </>
  );
}
